export enum RouteFragment {
  Activate = 'activate',
  Auth = 'auth',
  Banners = 'banners',
  Box = 'box',
  BoxCategory = 'box-category',
  BoxSale = 'box-sale',
  Boxes = 'boxes',
  Brands = 'brands',
  Client = 'client',
  Companies = 'companies',
  Company = 'company',
  Config = 'config',
  Cosmetics = 'cosmetics',
  Country = 'country',
  Create = 'create',
  Dashboard = 'dashboard',
  Details = 'details',
  Dictionaries = 'dictionaries',
  Edit = 'edit',
  Empty = '',
  Grid = 'grid',
  Home = 'home',
  Invoices = 'invoices',
  KsefConfiguration = 'ksef-configuration',
  List = 'list',
  Loading = 'loading',
  Localizations = 'localizations',
  Multimedia = 'multimedia',
  NotFound = '404',
  Orders = 'orders',
  PartialRefund = 'partial-refund',
  Owners = 'owners',
  Questionnaires = 'questionnaires',
  PL_Account = 'konto',
  PL_Addresses = 'adresy',
  PL_Authorization = 'autoryzacja',
  PL_BeautyProfile = 'profil-pieknosci',
  PL_Boxes = 'nasze-edycje',
  PL_Brands = 'marki-kosmetyczne',
  PL_Checkout = 'dostawa-i-platnosc',
  PL_Contact = 'kontakt',
  PL_Cosmetics = 'kosmetyki',
  PL_Details = 'szczegoly',
  PL_FAQ = 'faq',
  PL_Page = 'strona',
  PL_Order = 'zamowienie',
  PL_OrderBox = 'zamow-box',
  PL_Orders = 'zamowienia',
  PL_Payment = 'platnosc',
  PL_PrivacyPolicy = 'polityka-prywatnosci',
  PL_Products = 'produkty',
  PL_Questionnaires = 'ankiety',
  PL_PublishingOpinions = 'publikowanie-opinii',
  PL_Redirection = 'przekierowanie',
  PL_Regulations = 'regulamin',
  PL_Shop = 'sklep',
  PL_ShoppingCart = 'koszyk',
  PL_Subscriptions = 'subskrypcje',
  PL_Summary = 'podsumowanie',
  Pages = 'pages',
  FaqCategory = 'faq-category',
  Password = 'password',
  PaymentMethods = 'payment-methods',
  PriceChange = 'price-change',
  ProductAttribute = 'product-attribute',
  Products = 'products',
  Receipts = 'receipts',
  Redirect = 'redirect',
  RefundSettings = 'refund-settings',
  Releases = 'releases',
  Remind = 'remind',
  Reset = 'reset',
  Restocks = 'restocks',
  Root = '/',
  ShippingMethods = 'shipping-methods',
  ShippingSettings = 'shipping-settings',
  SignIn = 'sign-in',
  SignOut = 'sign-out',
  SignUp = 'sign-up',
  Subscribe = 'subscribe',
  Subscriptions = 'subscriptions',
  Upload = 'upload',
  Users = 'users',
  ValidationSettings = 'validation-settings',
  CartSettings = 'cart-settings',
  BackgroundTasks = 'background-tasks',
  Notifications = 'notifications',
  Warehouse = 'warehouse',
  Wildcard = '**',
}
